"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledSpinner = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _lodash = require("lodash");

var _axios = _interopRequireDefault(require("axios"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledSpinner = (0, _styledComponents.default)(_fiverReactUiComponents.Spinner)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 1rem;\n  margin: auto;\n"])));
exports.StyledSpinner = StyledSpinner;

var SignupStep = function SignupStep(_ref) {
  var translations = _ref.translations,
      onStepClicked = _ref.onStepClicked,
      isStepValid = _ref.isStepValid,
      values = _ref.values,
      errors = _ref.errors,
      dirty = _ref.dirty,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      setFieldValue = _ref.setFieldValue,
      setFieldTouched = _ref.setFieldTouched,
      dialingCode = _ref.dialingCode,
      isNonUk = _ref.isNonUk,
      colorPrimary = _ref.colorPrimary,
      touched = _ref.touched;
  (0, _react.useEffect)(function () {
    if (values.mobileNumber === "") {
      setFieldValue("mobileNumber", "+".concat(dialingCode));
      setFieldValue("mobileNumberConfirm", "+".concat(dialingCode));
    }
  }, [dialingCode]);
  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "registration_contact_details", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      asyncPostCodeError = _useState2[0],
      setAsyncPostCodeError = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      postCodeLoading = _useState4[0],
      setPostCodeLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      postCodeOptions = _useState6[0],
      setPostCodeOptions = _useState6[1];

  var handleChangePostCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, callback) {
      var _e$target, value, name;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _e$target = e.target, value = _e$target.value, name = _e$target.name;

              if (!(value.length >= 5 && value.length <= 8)) {
                _context.next = 5;
                break;
              }

              setPostCodeLoading(true);
              _context.next = 5;
              return _axios.default.get("/address-lookup/postcode/".concat(value)).then(function (_ref3) {
                var _data$data$, _data$data$2, _data$data$3;

                var data = _ref3.data;
                setPostCodeLoading(false);
                setPostCodeOptions(data.data);
                setAsyncPostCodeError(undefined);
                setFieldValue("street1", data === null || data === void 0 ? void 0 : data.data[0].line1);
                setFieldTouched("street1", true, true);
                setFieldValue("street2", data === null || data === void 0 ? void 0 : (_data$data$ = data.data[0]) === null || _data$data$ === void 0 ? void 0 : _data$data$.line2);
                setFieldValue("city", data === null || data === void 0 ? void 0 : (_data$data$2 = data.data[0]) === null || _data$data$2 === void 0 ? void 0 : _data$data$2.city);
                setFieldTouched("city", true, true);
                setFieldValue("county", data === null || data === void 0 ? void 0 : (_data$data$3 = data.data[0]) === null || _data$data$3 === void 0 ? void 0 : _data$data$3.county);
              }).catch(function () {
                setPostCodeLoading(false);
                setPostCodeOptions(undefined);
                setAsyncPostCodeError(translations.postcodeDoesntExist);
                setFieldValue("street1", '');
                setFieldTouched("street1", true, true);
                setFieldValue("street2", '');
                setFieldValue("city", '');
                setFieldTouched("city", true, true);
                setFieldValue("county", '');
              });

            case 5:
              callback(name, true, true);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChangePostCode(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handlePostCodeOptionChanged = function handlePostCodeOptionChanged(e) {
    var target = e.target;

    if (postCodeOptions) {
      var address = postCodeOptions[target.value];
      setFieldValue("postcode", address.postcode);
      setFieldValue("street1", address.line1);
      setFieldValue("street2", address.line2);
      setFieldValue("city", address.city);
      setFieldValue("county", address.county);
    }
  };

  var refHandler = (0, _react.useRef)((0, _lodash.debounce)(handleChangePostCode, 350));
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.TitleStack, {
    title: "".concat(translations.step, " 2"),
    subtitle: translations.messageContactDetails
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    textAlign: "left"
  }, translations.signUpMobileWarning, " +", dialingCode, "123456789")), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    type: "tel",
    name: "mobileNumber",
    placeholder: translations.mobileNumber,
    value: values.mobileNumber,
    isError: touched.mobileNumber && errors.mobileNumber,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.mobileNumber && errors.mobileNumber
  }, errors.mobileNumber), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    type: "tel",
    name: "mobileNumberConfirm",
    placeholder: "".concat(translations.confirm, " ").concat(translations.mobileNumber),
    value: values.mobileNumberConfirm,
    isError: touched.mobileNumberConfirm && errors.mobileNumberConfirm,
    onChange: handleChange,
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.mobileNumberConfirm && errors.mobileNumberConfirm
  }, errors.mobileNumberConfirm), true && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    name: "postcode",
    placeholder: translations.postcode,
    value: values.postcode,
    isRequired: true,
    validateOnChange: true,
    isError: touched.postcode && errors.postcode,
    onChange: function onChange(e) {
      handleChange(e);
      refHandler.current(e, setFieldTouched);
    },
    onBlur: function onBlur(e) {
      handleBlur(e);
    }
  }), postCodeLoading && /*#__PURE__*/_react.default.createElement(StyledSpinner, {
    colorPrimary: colorPrimary,
    lineWidth: 5
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.postcode && errors.postcode || asyncPostCodeError
  }, errors.postcode, !errors.postcode ? asyncPostCodeError : ""), (touched.postcode && errors.postcode || asyncPostCodeError) && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
    style: {
      padding: "1rem 0 0"
    }
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    alignItems: "center",
    checked: values.enterAddressManually,
    label: "Enter Address Manually",
    onChange: handleChange,
    name: "enterAddressManually"
  })), postCodeOptions ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormSelect, {
    isRequired: true,
    onChange: handlePostCodeOptionChanged,
    name: "street1",
    placeholder: "Address Line 1"
  }, postCodeOptions.map(function (o, index) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: index
    }, o.line1);
  }))) : null, ((errors.postcode || asyncPostCodeError) && values.enterAddressManually || (postCodeOptions === null || postCodeOptions === void 0 ? void 0 : postCodeOptions.length) === 0) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "street1",
    isError: touched.street1 && errors.street1,
    value: values.street1,
    placeholder: "Address Line 1"
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.street1 && errors.street1
  }, errors.street1)), (values.street1 || values.enterAddressManually) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "street2",
    value: values.street2,
    placeholder: "Address Line 2"
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    isRequired: true,
    onChange: handleChange,
    onBlur: handleBlur,
    name: "city",
    isError: touched.city && errors.city,
    value: values.city,
    placeholder: "City / Town"
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: touched.city && errors.city
  }, errors.city), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    name: "county",
    value: values.county,
    placeholder: "County"
  })))), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(2);
    },
    disabled: !dirty || !isStepValid,
    style: {
      marginBottom: "1rem"
    }
  }, translations.next), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(0);
    },
    isDefault: true
  }, translations.back));
};

var _default = SignupStep;
exports.default = _default;